export enum CardTransactionColumns {
  Status = 'Status',
  Card = 'Card',
  Date = 'Date',
  Description = 'Description',
  Amount = 'Amount',
  Fee = 'Fee',
  TotalSpent = 'Total Spent',
  Category = 'Category',
  Receipt = 'Receipt',
  Note = 'Note',
}
